module.exports = __webpack_public_path__ + "img/werder.11f596f7.png";